import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import {
  CreateTransactionParams,
  DeleteTransactionByIdResponse,
  GetTransactionByIdResponse, GetTransactionRequestParams,
  GetTransactionResponse, UpdateTransactionRequestParams
} from '../../pages/transactions/transactions.interface';
import { environment } from '../../../environments/environment';
import { toQueryString } from '../../shared/helpers/helpers';

@Injectable({
  providedIn: 'root'
})
export class TransactionsService {
  private apiUrl = environment.api + '/transactions';

  constructor(private http: HttpClient) {}

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getTransactionService(requestParams: GetTransactionRequestParams): Observable<GetTransactionResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetTransactionResponse>(url).pipe(
      tap(response => this.handleResponse(response)), // ✅ Pakai arrow function
      catchError(error => this.handleError(error))   // ✅ Pakai arrow function
    );
  }

  getTransactionById(id: string): Observable<GetTransactionByIdResponse> {
    return this.http.get<GetTransactionByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  deleteTransactionById(id: string): Observable<DeleteTransactionByIdResponse> {
    return this.http.delete<DeleteTransactionByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  createTransaction(transactionData: CreateTransactionParams): Observable<GetTransactionByIdResponse> {
    return this.http.post<GetTransactionByIdResponse>(this.apiUrl, transactionData).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  updateTransaction(id: string, transactionData: UpdateTransactionRequestParams): Observable<GetTransactionByIdResponse> {
    return this.http.put<GetTransactionByIdResponse>(`${this.apiUrl}/${id}`, transactionData).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }
}
